import React from "react";
import PropTypes from "prop-types";

/**
 * RightSheetSection — one block of drawer body content with the standard rhythm.
 *
 * 14px semibold heading, 12px to the content, 28px between consecutive sections.
 * Consumers stop re-deciding drawer spacing per feature.
 */
export default function RightSheetSection({ title, actions, children, className = "" }) {
  return (
    <section className={`mt-7 first:mt-0 ${className}`}>
      {(title || actions) && (
        <div className="flex items-center justify-between gap-3 mb-3">
          {title ? (
            <h3 className="text-sm font-semibold text-text">{title}</h3>
          ) : (
            <span />
          )}
          {actions && <div className="flex-shrink-0">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

RightSheetSection.propTypes = {
  title: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};
